module.exports = __webpack_public_path__ + "img/RJMT_location_brown.f56a9c9d.svg";